module.exports = __webpack_public_path__ + "img/background_Image.1a19b915.png";